// extracted by mini-css-extract-plugin
export var cell = "_5g-4";
export var headerCell = "_5g-2";
export var rowHeader = "_5g-3";
export var table = "_5g-1";
export var tableContainer = "_5g-0";